// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"396b6eae","99":"08888d42","146":"bd5398a6","175":"dc0ef819","204":"6cd05a70","349":"c7d7c530","479":"44f4cc2b","655":"a9035cee","674":"22838763","768":"f3b92289","813":"1779a449","963":"25b530ee"}[chunkId] + ".chunk.js";
};